import React from 'react';
import { toast } from 'react-toastify';

import { Bloc } from '@mairistem/administres-utils';
import { request } from '@mairistem/tools';
import { BlocTile } from '@/components/Common';
import useEntiteStore from '@/zustand/useEntiteStore';
import { PARAM_NUMERISES, TYPES_ACTES_TABLEAU_DE_BORD } from '@/constants';

import PacsModal from '../Modals/ActeModal';

interface BlocSynthetiqueProps {
  style?: React.CSSProperties;
  setLoading: (loading: boolean) => void;
}

type SelectedTypeActe =
  | 'naissance'
  | 'reconnaissance'
  | 'mariage'
  | 'deces'
  | 'mention';

const MODAL_TITLE_BY_TYPE_ACTE: Record<SelectedTypeActe, string> = {
  naissance: 'Liste des actes de naissances',
  reconnaissance: 'Liste des actes de reconnaissances',
  mariage: 'Liste des actes de mariages',
  deces: 'Liste des actes de décès',
  mention: 'Liste des mentions',
};

const BlocSynthetique = (props: BlocSynthetiqueProps) => {
  const { style, setLoading } = props;

  const [statsSynthese, setStatsSynthese] = React.useState<any>(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedType, setSelectedType] = React.useState<
    SelectedTypeActe | undefined
  >(undefined);
  const blocked = useEntiteStore((state) => state.blocked);

  React.useEffect(() => {
    if (!blocked) {
      setLoading(true);
      request
        .get(
          `/api/administres/etat-civil/numerisation-actes/synthese?${PARAM_NUMERISES}`,
        )
        .then((data) => {
          setStatsSynthese(data);
        })
        .catch(() => {
          toast.error(
            'Une erreur est survenue lors de la récupération de la synthèse',
          );
        })
        .finally(() => setLoading(false));
    }
  }, [blocked, setLoading]);

  return (
    <Bloc
      icon="file text"
      header={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div>Vue synthétique</div>
        </div>
      }
      style={style}
    >
      {/* 3 + 2 : les cinq cartes ne tiennent pas sur une seule ligne. */}
      {[
        TYPES_ACTES_TABLEAU_DE_BORD.slice(0, 3),
        TYPES_ACTES_TABLEAU_DE_BORD.slice(3),
      ].map((ligne, index) => (
        <div
          key={ligne[0].key}
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            gap: '1em',
            marginTop: index === 0 ? '1.5em' : '1em',
          }}
        >
          {ligne.map((type) => (
            <BlocTile
              key={type.key}
              title={type.text}
              stats={
                statsSynthese
                  ? statsSynthese[
                      type.key.endsWith('s') ? type.key : `${type.key}s`
                    ]
                  : '0'
              }
              statsColor={type.statsColor}
              textColor={type.textColor}
              onClick={
                type.key === 'mention'
                  ? undefined
                  : () => {
                      setSelectedType(type.key as typeof selectedType);
                      setOpenModal(true);
                    }
              }
              icon={type.icon}
            />
          ))}
        </div>
      ))}
      <PacsModal
        open={openModal}
        title={selectedType ? MODAL_TITLE_BY_TYPE_ACTE[selectedType] : ''}
        typeActe={selectedType}
        onClose={() => {
          setOpenModal(false);
          setSelectedType(undefined);
        }}
      />
    </Bloc>
  );
};

export default BlocSynthetique;
